export const JobFunnelNameOptions: { [key: string]: string } = {
    Applied: 'applicant-tracker.applied',
};
